import {Routes} from '@angular/router';
import {AuthGuard} from '../guards/auth.guard';
import {ErrorComponent} from './error/error.component';
import {MyAccountComponent} from './my-account/my-account.component';
import {VerifyCustomerComponent} from './verify-customer/verify-customer.component';
import {LeadDetailsComponent} from './verify-customer/lead-details/lead-details.component';
import {UserDetailsComponent} from './verify-customer/user-details/user-details.component';
import {ReportsComponent} from './reports/reports.component';
import {VerifyKycComponent} from './verify-customer/verify-kyc/verify-kyc.component';
import {KycDetailsComponent} from './verify-customer/kyc-details/kyc-details.component';
import {LeadCreateComponent} from '../components/verify-customer/lead-create/lead-create.component';
import {DownloadComponent} from "./download/download.component";
import {ContainerOffHireComponent} from './off-hire-containers/container-off-hire/container-off-hire.component';
import {OpsDataChangeComponent} from "./ops-data-change/ops-data-change.component";
import {
    OpsDateChangeRequestDetailsComponent
} from "./ops-data-change/ops-date-change-request-details/ops-date-change-request-details.component";
import {OpsDateChangeListComponent} from "./ops-data-change/ops-date-change-list/ops-date-change-list.component";
import { OpsDateChangeViewComponent } from './ops-data-change/ops-date-change-view/ops-date-change-view.component';

export const PagesRoutes: Routes = [
    {
        path: '',
        children: [
            {
                path: '404',
                component: ErrorComponent,
            },
            {
                path: 'my-account',
                component: MyAccountComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'verify-customer',
                component: VerifyCustomerComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'verify-customer/leads',
                component: LeadDetailsComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'verify-customer/users',
                component: UserDetailsComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'verify-customer-kyc',
                component: VerifyKycComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'verify-customer-kyc/kyc-details',
                component: KycDetailsComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'reports',
                component: ReportsComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'create-leads',
                component: LeadCreateComponent,
                // canActivate: [AuthGuard]
            },
            {
                path: 'download',
                component: DownloadComponent,
                // canActivate: [AuthGuard]
            },
            {
                path: 'off-hire-containers',
                component: ContainerOffHireComponent,
                // canActivate: [AuthGuard]
            },
            {
                path: 'ops-date-change',
                component: OpsDataChangeComponent,
                // canActivate: [AuthGuard]
            },
            {
                path: 'ops-date-change/request-details',
                component: OpsDateChangeRequestDetailsComponent,
                // canActivate: [AuthGuard]
            },
            {
                path: 'ops-date-change/list',
                component: OpsDateChangeListComponent,
                // canActivate: [AuthGuard]
            },
            {
                path: 'ops-date-change/view',
                component: OpsDateChangeViewComponent,
                // canActivate: [AuthGuard]
            },
        ],
    },
];
